document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href]');
  if (!link) return;
  var map = {
    '/collections/pony-clubs-menu': '/pages/pony-clubs-directory',
    '/collections/riding-clubs-menu': '/pages/riding-clubs-directory',
    '/collections/schools-colleges-menu': '/pages/schools-colleges-directory',
    '/collections/rda-menu': '/pages/rda-directory',
    '/collections/other-societies-menu': '/pages/other-societies-directory',
    '/collections/events-menu': '/pages/events-directory',
    '/collections/set-up-your-club': '/pages/contact'
  };
  var href = link.getAttribute('href');
  if (!href) return;
  var path = href.split('?')[0];
  if (map[path]) {
    e.preventDefault();
    window.location.href = map[path];
  }
}, true);
